import React from 'react'
import { useTranslate, Button } from 'react-admin'
import { Box, Typography, List, ListItem, ListItemText, ListItemIcon } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { CANCELLED, DELETED, EXPIRED } from '../common/state'

export const TrainSegmentTicket = ({ ticket_url, ticketing_options, status, status_segment }) => {
  const translate = useTranslate()
  if (
    ticket_url &&
    Array.isArray(ticket_url) &&
    ticket_url.length > 0 &&
    status === 'INVOICED' &&
    ticket_url.every((record) => 'url' in record)
  ) {
    return (
      <Box>
        <Typography variant='h7' component='div' textAlign={'center'} fontWeight={600}>
          {translate('ra.title.tickets')}
        </Typography>
        <Box display={'flex'} width={'100%'}>
          {ticket_url.map((elem, key) => {
            return (
              elem?.url && (
                <Button
                  key={key}
                  component='a'
                  href={`${elem?.url}`}
                  style={{ width: 'auto', margin: '0 5px 0 5px' }}
                  size='medium'
                  target='_blank'
                  rel='noopener noreferrer'
                  variant='contained'
                  onClick={(e) => e.stopPropagation()}
                >
                  <PictureAsPdfIcon /> Ticket
                </Button>
              )
            )
          })}
        </Box>
      </Box>
    )
  } else {
    if (
      ticketing_options &&
      Array.isArray(ticketing_options) &&
      ticketing_options.length > 0 &&
      typeof ticketing_options[0] === 'string' &&
      status_segment !== CANCELLED &&
      status_segment !== EXPIRED &&
      status_segment !== DELETED
    ) {
      return (
        <Box>
          <Typography variant='h7' component='div' textAlign={'center'} fontWeight={600}>
            {translate('ra.title.tickets')}
          </Typography>
          <List>
            {ticketing_options.map((item, index) => {
              if (typeof item === 'string') {
                return (
                  <ListItem key={index}>
                    <ListItemIcon>
                      <FiberManualRecordIcon />
                    </ListItemIcon>
                    <ListItemText primary={item} />
                  </ListItem>
                )
              }
              return null
            })}
          </List>
        </Box>
      )
    }
  }
}
